var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 4.25H4.25V29.75H29.75V4.25Z",
    fill: "#ECEFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.6816L29.75 29.7498V9.87256L17 19.6816Z",
    fill: "#CFD8DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8125 4.25H29.75L17 14.3182L4.25 4.25H3.1875C1.428 4.25 0 5.678 0 7.4375V26.5625C0 28.322 1.428 29.75 3.1875 29.75H4.25V9.87275L17 19.6796L29.75 9.87063V29.75H30.8125C32.572 29.75 34 28.322 34 26.5625V7.4375C34 5.678 32.572 4.25 30.8125 4.25Z",
    fill: "#F44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGmail);
export default __webpack_public_path__ + "static/media/IconGmail.8ba8687552d51576f4c42298e1f84a67.svg";
export { ForwardRef as ReactComponent };